import React from 'react';
import PropTypes from 'prop-types';

import './RsTableHeaderLabel.scss';

function RsTableHeaderLabel({ children }) {
  return <div className="rs-table-header-label">{children || ' '}</div>;
}

RsTableHeaderLabel.propTypes = {
  children: PropTypes.node,
};

export default RsTableHeaderLabel;
